import Handler from "../Handler";

class ShowCardsHandler extends Handler {
  execute(message) {
    const receivedData = JSON.parse(message);
    this.service.processShownCards(receivedData);
  }
}

export default ShowCardsHandler;
